import React from "react";
import { motion } from "framer-motion";

import home1 from "../assets/home 1.webp";
import home2 from "../assets/home2.webp";
import home3 from "../assets/home3.webp";
import towel6 from "../assets/towel6.webp";
import { Award, Leaf, Heart, Globe } from "lucide-react";

const MainContainer = () => {
  return (
    <div className="w-full bg-white overflow-x-hidden">
      {/* Hero Section */}
      {/* Hero Section */}
      <section className="relative w-full h-screen flex flex-col justify-start md:justify-center  items-center text-center">
        <img
           src="/startImg.webp"
          alt="Hero section"
          className="absolute top-0 left-0 w-full h-full object-cover opacity-85"
        />
        <div className="relative z-10 px-6 md:mt-0 mt-[22%]">
          {/* Heading */}
          <motion.h1
            className="text-5xl md:text-8xl font-bold  text-[#866858f3] 
       btext-transparent bg-clip-text 
        bg-gradient-to-r from-lime-200 via-lime-400 to-emerald-500 drop-shadow-lg"
            initial={{ opacity: 0, x: 120 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}>
            Mansafa Towels
          </motion.h1>

          {/* Subheading */}
          <motion.p
            className="text-lg  text-[#5f483bf3] mt-2 italic"
            initial={{ opacity: 0, x: 120 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}>
            A product of <span className="font-semibold">EMMEF TEX</span>
          </motion.p>

          {/* Paragraph below → opposite direction */}
          <motion.p
            className="text-xl md:text-7xl text-black font-bold mt-10 max-w-3xl mx-auto  
         drop-shadow-2xl"
            initial={{ opacity: 0, x: -120 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}>
            Where comfort meets elegance, woven with care.
          </motion.p>
        </div>
      </section>

      {/* Product Images + Text */}
      <section className="px-8 md:px-20 py-16">
        <div className="flex flex-col items-center">
          {/* 3 Images */}
          <div className="flex flex-col md:flex-row justify-center gap-6 w-full mb-12">
            {[home1, home2, home3].map((img, i) => (
              <div
                key={i}
                className="w-full md:w-1/3 aspect-[4/3] rounded-3xl overflow-hidden"
                data-aos="zoom-in">
                <img
                  src={img}
                  alt={`Product ${i + 1}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>

          {/* Text */}
          <h2
            className="text-3xl md:text-5xl font-bold text-gray-800 mb-4 mt-4"
            data-aos="fade-left">
            Soft & Comfy Towels
          </h2>
          <p
            className="text-lg md:text-2xl text-gray-700 max-w-2xl text-center"
            data-aos="fade-left">
            Discover our premium quality towels, designed for comfort and style.
            Perfect for your home or gifts!
          </p>
        </div>
      </section>

      {/* Feature Image + Cards */}
      <section className="px-8 md:px-24 py-10 flex flex-col md:flex-row gap-12 items-start ">
        {/* Left Image */}
        <motion.img
          src={towel6}
          alt="Feature"
          className="w-full md:w-1/2 rounded-3xl object-cover"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        />

        {/* Right Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 w-full md:w-1/2">
          {[
            {
              icon: (
                <Award className="w-10 h-10 text-orange-500 mx-auto mb-4" />
              ),
              title: "40+ Years of Excellence",
              text: "Four decades of mastering textile craftsmanship and innovation",
            },
            {
              icon: <Leaf className="w-10 h-10 text-orange-500 mx-auto mb-4" />,
              title: "Sustainable Practices",
              text: "Committed to eco-friendly materials and responsible",
            },
            {
              icon: (
                <Heart className="w-10 h-10 text-orange-500 mx-auto mb-4" />
              ),
              title: "Uncompromising Quality",
              text: "Every towel crafted with meticulous attention to detail",
            },
            {
              icon: (
                <Globe className="w-10 h-10 text-orange-500 mx-auto mb-4" />
              ),
              title: "Global Trust",
              text: "Serving customers worldwide with dedication and reliability",
            },
          ].map((item, i) => (
            <motion.div
              key={i}
              className="bg-white shadow-lg rounded-2xl p-6 text-center"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}>
              {item.icon}
              <h3 className="text-lg font-bold text-gray-900">{item.title}</h3>
              <p className="text-gray-600 mt-2">{item.text}</p>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default MainContainer;
